module.exports = __webpack_public_path__ + "img/hill24.dd8c0657.jpg";